import { render, staticRenderFns } from "./AnnotationRecordItemFeatureForm.vue.js?vue&type=template&id=92f81d94&scoped=true!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./AnnotationRecordItemFeatureForm.vue?vue&type=template&id=92f81d94&scoped=true"
import script from "./AnnotationRecordItemFeatureForm.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./AnnotationRecordItemFeatureForm.vue?vue&type=script&lang=js"
export * from "./AnnotationRecordItemFeatureForm.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./AnnotationRecordItemFeatureForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92f81d94",
  null
  
)

export default component.exports